import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
var styles = xcss({
  width: '360px'
});
export var AgentProfileCardWrapper = function AgentProfileCardWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles
  }, children);
};